<template>
  <v-row class="pa-0">
    <v-col cols="12" xs="12">
      <TableDevices :showTitle="false" ref="table" :companyId="companyId" :isCompanyView="true"/>
    </v-col>

    <v-col cols="12" v-if="true" class="pb-0">
      <v-row class="pa-0">
        <v-col cols="12" xs="12" justify="end">
          <v-btn @click="openCreatePL" color="primary">Playlist erstellen</v-btn>
        </v-col>
      </v-row>
    </v-col>
    <DialogCreateAndLinkPlaylist ref="dlgCreatePL" @save="onCreatePL"></DialogCreateAndLinkPlaylist>
  </v-row>
</template>

<script>
import Vue from 'vue'
import DialogCreateAndLinkPlaylist from './../../module/dialogs/DialogCreateAndLinkPlaylist'
import TableDevices from "../../tables/TableDevices";

export default {
  name: 'TabDevices',
  components: {TableDevices, DialogCreateAndLinkPlaylist},
  props: {
    companyId: String
  },
  methods: {
    openCreatePL: function () {
      console.log('openCreatePL')
      this.$refs.dlgCreatePL.open({
        title: 'Playlist erstellen',
        description: 'Wählen Sie Playlisten zum erstellen und zuweisen neuer Playlisten aus'
      })
    },
    onCreatePL: function (playListItems) {
      console.log('onCreatePL To selected', playListItems, this.$refs.table.selected)
      let deviceArrGuids = []
      for (let i in this.$refs.table.selected) {
        let item = this.$refs.table.selected[i]
        deviceArrGuids.push(item.guid)
      }
      let plGuids = []
      for (let i in playListItems) {
        let item = playListItems[i]
        plGuids.push(item.guid)
      }
      Vue.prototype.$api.createPlayListToDevices(plGuids, deviceArrGuids, this.reload)
    },
    open: function () {
    },
    reload: function () {
      this.$refs.table.reload()
    }
  },
  data() {
    return {}
  },
  mounted() {

  }
}
</script>

<style scoped>

</style>
